var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyDoubleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9ca3af",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "double-right-sign-square",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line",
    stroke: "#9ca3af",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "primary",
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 1,
    style: {
      fill: "none",
      stroke: "#9ca3af",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary-2",
    "data-name": "primary",
    points: "13 9 16 12 13 15",
    style: {
      fill: "none",
      stroke: "#9ca3af",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary-3",
    "data-name": "primary",
    points: "8 9 11 12 8 15",
    style: {
      fill: "none",
      stroke: "#9ca3af",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDoubleRight);
export default __webpack_public_path__ + "static/media/grey-double-right.50fced8e1a3e022f63df7f78aea7697f.svg";
export { ForwardRef as ReactComponent };